/**
 * A ticking clock for elapsed/ETA readouts.
 *
 * Elapsed time is derived at render from `Date.now()` rather than stored in the
 * session store, so a running job does not push a state update every second
 * through every subscriber.
 */

import { useEffect, useState } from "react";

export function useNow(intervalMs = 1000, active = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, active]);
  return now;
}
